var map = {
	"./baac.svg": 623,
	"./bay.svg": 624,
	"./bbl.svg": 625,
	"./bnp.svg": 626,
	"./boa.svg": 627,
	"./cacib.svg": 628,
	"./cimb.svg": 629,
	"./citi.svg": 630,
	"./db.svg": 631,
	"./ghb.svg": 632,
	"./gsb.svg": 633,
	"./hsbc.svg": 634,
	"./ibank.svg": 635,
	"./icbc.svg": 636,
	"./jpm.svg": 637,
	"./kbank.svg": 638,
	"./kk.svg": 639,
	"./ktb.svg": 640,
	"./lhb.svg": 641,
	"./mb.svg": 642,
	"./mega.svg": 643,
	"./mufg.svg": 644,
	"./rbs.svg": 645,
	"./sc.svg": 646,
	"./scb.svg": 647,
	"./smbc.svg": 648,
	"./tbank.svg": 649,
	"./tcrb.svg": 650,
	"./tisco.svg": 651,
	"./tmb.svg": 652,
	"./uob.svg": 653
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 79
// module chunks = 1